module.exports = __webpack_public_path__ + "static/media/Coupon.f4a363e2.svg";